class SpinnerOverlay {
    constructor(documentRef) {
        this.documentRef = documentRef || document;
        this.overlayElement = null;
        this.activeCount = 0;
        this.styleElementId = 'ip-spinner-overlay-style';
    }

    show() {
        this.activeCount += 1;
        if (this.activeCount > 1) {
            return;
        }

        this.#ensureStyle();

        const overlay = this.documentRef.createElement('div');
        overlay.className = 'ip-spinner-overlay';
        overlay.innerHTML = '<div class="ip-spinner-overlay__spinner" aria-hidden="true"></div>';
        this.documentRef.body.appendChild(overlay);
        this.overlayElement = overlay;
    }

    hide() {
        this.activeCount = Math.max(0, this.activeCount - 1);
        if (this.activeCount > 0) {
            return;
        }

        if (this.overlayElement) {
            this.overlayElement.remove();
            this.overlayElement = null;
        }
    }

    #ensureStyle() {
        if (this.documentRef.getElementById(this.styleElementId)) {
            return;
        }

        const style = this.documentRef.createElement('style');
        style.id = this.styleElementId;
        style.textContent = `
            .ip-spinner-overlay {
                position: fixed;
                inset: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(255, 255, 255, 0.45);
                z-index: 9999;
            }

            .ip-spinner-overlay__spinner {
                width: 42px;
                height: 42px;
                border: 4px solid rgba(0, 0, 0, 0.2);
                border-top-color: rgba(0, 0, 0, 0.7);
                border-radius: 50%;
                animation: ip-spinner-overlay-rotate 0.8s linear infinite;
            }

            @keyframes ip-spinner-overlay-rotate {
                to { transform: rotate(360deg); }
            }
        `;

        this.documentRef.head.appendChild(style);
    }
}

export default SpinnerOverlay;
